import React from 'react';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import s from './ModalHeadingText.scss';

interface Props {}

/**
 * The heading text we use for modals.
 */
const ModalHeadingText: React.FC<React.PropsWithChildren<Props>> = ({ children }) => (
  <Heading className={s['root']}>{children}</Heading>
);
ModalHeadingText.displayName = 'ModalHeadingText';

export default ModalHeadingText;
